
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns5f99c0748a8ef267546195f03e4d6c1aen from './en.yaml'
            i18n.addResourceBundle('en', '5f99c0748a8ef267546195f03e4d6c1a', flattenObject(ns5f99c0748a8ef267546195f03e4d6c1aen), true, true);
        
        export default '5f99c0748a8ef267546195f03e4d6c1a';
    